<template>
  <b-modal
    id="feedbackModal"
    size="lg"
    :title-html=" '<i class=\'uil-edit text-warning\'></i>' + $t('job.applicant_window.action.add_feedback.title')"
    title-class="font-18"
    no-close-on-esc
    no-close-on-backdrop
    centered
    body-class="bg-light"
    static
    :ok-title-html="'<i class=\'uil-edit\'></i>' + $t('job.applicant_window.action.add_feedback.ok_button')"
    ok-variant="warning"
    @ok="handleOk"
    @cancel="handleCancel"
    button-size= 'sm'
    :cancel-title= "$t('job.applicant_window.action.add_feedback.cancel_button')"
    footer-class= 'p-2'
    hide-header-close
    >
    <div class="row">
      <div class="form-group col-md-6">
        <label class="form-label">{{$t('job.applicant_window.action.add_feedback.description.label')}}:</label>
        <textarea 
          class="form-control"
          v-model="description"
          rows="10" :placeholder="$t('job.applicant_window.action.add_feedback.description.placeholder') + '...'"></textarea>
      </div>
      <div class="col-md-6">
        <div class="h6"> {{$t('job.applicant_window.action.add_feedback.feedback')}}:</div>
        <div class="row">
          <div
            class="col-md-12 text-center text-muted" 
            v-if="feeds.length == 0">
            {{$t('job.applicant_window.action.add_feedback.empty_feedback')}}.
          </div>
          <VuePerfectScrollbar style="max-height:250px"
            v-if="feeds.length > 0">
            <div class="media col-md-12 mb-2"
              v-for="item in feeds"
              :key="item._id"
              >
              <div>
                <div class="h6 m-0">{{ item.date_created | date}} <span class="text-muted small">- Anonymous</span></div>
                <div class="text-muted small">{{item.description}}</div>
              </div>
            </div>
          </VuePerfectScrollbar>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapActions } from 'vuex'
import moment from 'moment/moment'

export default {
  data(){
    return {
      description:''
    }
  },
  components:{VuePerfectScrollbar},
  props:['feedbacks', 'candidate', 'application'],
  computed:{
    feeds(){
      return this.feedbacks || []
    },
    getCandidateId(){
      return this.application.candidate_id._id || []
    },
    getApplicationId(){
      return this.application._id || []
    }
  },
  methods:{
    ...mapActions('candidate', ['addFeedback']),
    handleOk(bvModalEvt){
      bvModalEvt.preventDefault()

      this.addFeedback({
        application_id:this.getApplicationId,
        candidate_id:this.getCandidateId,
        description:this.description
      }).then(res => {
        if(res.data){
          this.$props.feedbacks.push(res.push)
          this.$bvToast.toast(`Your feedback was added to this candidate application!`, {
            title: 'Notification',
            variant:'success'
          })
          this.$bvModal.hide('feedbackModal')
          this.description = ''
        }
      })
    },
    handleCancel(){
      
    }
  },
  filters:{
    date:function(v){
      return moment(v).format('MMM DD, YYYY LT')
    }
  }
}
</script>
